export default "__VITE_ASSET__Dbv8qx5r__"